import { Inject, Injectable } from '@angular/core';
import { marker as i18n } from '@ngneat/transloco-keys-manager/marker';
import { map, Observable } from 'rxjs';
import { TranslateFunction } from '@bbraun/shared/util-transloco-ng';
import {
  ValidatorFactory,
  ValidatorFactoryFunction,
} from '@bbraun/bav-reporting/ui-report-editor';
import { createIsPropertyAndValueNumberOrBothNotNumberValidator } from '../create-validators';
import { FeatureAisReportsScopedTranslationService } from '../../../services/feature-ais-reports-scoped-translation.service';

export const VALUE_AND_LINKED_PROPERTY_ARE_NUMBER_OR_BOTH_NOT_NUMBER_VALIDATOR_ID =
  'VALUE_AND_LINKED_PROPERTY_ARE_NUMBER_OR_BOTH_NOT_NUMBER_VALIDATOR';
export const VALUE_AND_LINKED_PROPERTY_ARE_NUMBER_OR_BOTH_NOT_NUMBER_VALIDATOR_ERROR =
  Symbol(VALUE_AND_LINKED_PROPERTY_ARE_NUMBER_OR_BOTH_NOT_NUMBER_VALIDATOR_ID);

@Injectable({
  providedIn: 'root',
})
export class IsPropertyAndValueNumberOrBothNotNumberValidatorFactory
  implements ValidatorFactory<{ linkedProperty: string }>
{
  readonly id =
    VALUE_AND_LINKED_PROPERTY_ARE_NUMBER_OR_BOTH_NOT_NUMBER_VALIDATOR_ID;
  readonly validatorFn: Observable<
    ValidatorFactoryFunction<{ linkedProperty: string }>
  >;

  constructor(
    @Inject(FeatureAisReportsScopedTranslationService)
    private readonly scopedTranslationService: {
      loadedLang$: Observable<{ translate: TranslateFunction }>;
    },
  ) {
    this.validatorFn = this.scopedTranslationService.loadedLang$.pipe(
      map(({ translate }) => ({ linkedProperty }) => ({
        id: VALUE_AND_LINKED_PROPERTY_ARE_NUMBER_OR_BOTH_NOT_NUMBER_VALIDATOR_ERROR,
        validate:
          createIsPropertyAndValueNumberOrBothNotNumberValidator(
            linkedProperty,
          ),
        message: translate(
          i18n(
            'bbraunBavReportingFeatureAisReports.validation.propertyAndValue.notBothNumber.error.message',
          ),
        ),
      })),
    );
  }
}
